export default {"src":"/_next/static/media/icon-ai-image-abuse-detection.59ae0a1a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};